import {
  create,
  NConfigProvider,
  NMessageProvider,
  NDialogProvider,
  NInput,
  NButton,
  NForm,
  NFormItem,
  NCheckboxGroup,
  NCheckbox,
  NIcon,
  NSkeleton,
  // NLayout,
  // NLayoutHeader,
  // NLayoutContent,
  // NLayoutFooter,
  // NLayoutSider,
  NMenu,
  NBreadcrumb,
  // NBreadcrumbItem,
  // NDropdown,
  NSpace,
  NTooltip,
  // NAvatar,
  NTabs,
  NTabPane,
  NCard,
  NRow,
  NCol,
  // NDrawer,
  // NDrawerContent,
  NDivider,
  NSwitch,
  NBadge,
  NAlert,
  // NElement,
  NTag,
  // NNotificationProvider,
  NProgress,
  NDatePicker,
  NGrid,
  NGridItem,
  NList,
  NListItem,
  NThing,
  NDataTable,
  NPopover,
  NPopselect,
  NPagination,
  NSelect,
  NRadioGroup,
  NRadio,
  NSteps,
  NStep,
  // NInputGroup,
  // NResult,
  NDescriptions,
  NDescriptionsItem,
  NTable,
  NInputNumber,
  NLoadingBarProvider,
  NModal,
  NUpload,
  NTree,
  NSpin,
  // NTimePicker,
  // NBackTop,
  NEmpty,
  NAutoComplete,
  NImage,
  NTreeSelect,
  NCollapse,
  NCollapseItem,
  // NCollapseTransition,
  // NAffix,
  // NAnchor,
  // NCalendar,
  // NColorPicker,
  NCascader,
  NCode,
  // NDynamicInput,
  // NDynamicTags,
  NEllipsis,
  NTimeline,
  NTimelineItem,
} from 'naive-ui';

import type { App } from 'vue';

const naive = create({
  components: [
    // NCollapseTransition,
    NEllipsis,
    // NDynamicTags,
    // NDynamicInput,
    NCode,
    // NColorPicker,
    // NCalendar,
    // NAffix,
    // NAnchor,
    NMessageProvider,
    NDialogProvider,
    NConfigProvider,
    NInput,
    NButton,
    NForm,
    NFormItem,
    NCheckboxGroup,
    NCheckbox,
    NIcon,
    // NLayout,
    // NLayoutHeader,
    // NLayoutContent,
    // NLayoutFooter,
    // NLayoutSider,
    NMenu,
    NBreadcrumb,
    // NBreadcrumbItem,
    // NDropdown,
    NSpace,
    NTooltip,
    // NAvatar,
    NTabs,
    NTabPane,
    NCard,
    NRow,
    NCol,
    // NDrawer,
    // NDrawerContent,
    NDivider,
    NSwitch,
    NBadge,
    NAlert,
    // NElement,
    NTag,
    // NNotificationProvider,
    NProgress,
    NDatePicker,
    NGrid,
    NGridItem,
    NList,
    NListItem,
    NThing,
    NDataTable,
    NPopover,
    NPopselect,
    NPagination,
    NSelect,
    NRadioGroup,
    NRadio,
    NSteps,
    NStep,
    // NInputGroup,
    // NResult,
    NDescriptions,
    NDescriptionsItem,
    NTable,
    NInputNumber,
    NLoadingBarProvider,
    NModal,
    NUpload,
    NTree,
    NSpin,
    // NTimePicker,
    // NBackTop,
    NSkeleton,
    NEmpty,
    NAutoComplete,
    NImage,
    NTreeSelect,
    NCollapse,
    NCollapseItem,
    NCascader,
    NTimeline,
    NTimelineItem,
  ],
});

export function setupNaive(app: App<Element>) {
  app.use(naive);
}
